import React from 'react';

export default class HorizontalDividerElement extends React.Component {
	render() {
		return (
			<div className='horizontal divider'></div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/extras/horizontal-divider.js